module.exports = __webpack_public_path__ + "img/banner_img_icon_2.61ed0ed4.png";